import { OFFICE_API_VERSION } from "@core/core-boot/core-boot";
import { Observable } from "rxjs";
import { OFFICE_API_WEB_VERSION } from "@core/core-env/core-env";

export interface ICoreEnv {
    get: () => IClientENV
    $get: () => Observable<IClientENV>
    get isOffice(): boolean
    isHostOutlook: () => Promise<boolean>
}

export enum ePlatformCustom {
    CustomWeb = 'CustomWeb',
}

export enum eHostCustom {
    CustomHost = 'CustomHost'
}

export type IClientPlatform = Office.PlatformType | ePlatformCustom;
export type IClientHost = Office.HostType | eHostCustom;
export type IOfficeVersion = (typeof OFFICE_API_VERSION)[keyof typeof OFFICE_API_VERSION]

export interface IClientENV {
    platform: IClientPlatform,
    host: IClientHost,
    office: IOfficeVersion | typeof OFFICE_API_WEB_VERSION,
}
